"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilterButton = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.DateFilterButton = function (_a) {
    var isOpen = _a.isOpen, isMobile = _a.isMobile, title = _a.title, children = _a.children, disabled = _a.disabled;
    return (react_1.default.createElement("div", { className: classnames_1.default("s-date-filter-button", "gd-date-filter-button", "dropdown-button", isMobile && "gd-date-filter-button-mobile", isOpen && "is-active", disabled && "disabled") },
        react_1.default.createElement("div", { className: "button-content" },
            react_1.default.createElement("div", { className: "s-date-filter-title button-title" }, title),
            react_1.default.createElement("div", { className: "button-subtitle" }, children))));
};
//# sourceMappingURL=DateFilterButton.js.map